export const adjustColorForDarkBackground = (color) => {
  // If no color or invalid color, return white
  if (!color || color === "transparent") return "#ffffff";

  // Parse RGB/RGBA values
  const rgbMatch = color.match(
    /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/
  );
  if (!rgbMatch) return "#ffffff";

  const r = parseInt(rgbMatch[1]);
  const g = parseInt(rgbMatch[2]);
  const b = parseInt(rgbMatch[3]);

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // If color is already light enough, return it
  if (luminance > 0.5) return color;

  // Otherwise, return a lighter version
  return `rgb(${Math.min(255, r + 200)}, ${Math.min(255, g + 200)}, ${Math.min(255, b + 200)})`;
};

/**
 * Collection of color utility functions for color manipulation and processing.
 * Provides methods for adjusting colors for different backgrounds and themes.
 */
export const ColorUtils = {
  adjustColorForDarkBackground,
};
